import styled from "styled-components";

const ModulePageLayout = styled.div`
  .loading-component{
    text-align: center;
    height: 80vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  /* Hero */

  .hero {
    background: var(--hn-black);
    padding: 64px 64px;
    text-align: center;
    border-bottom: 1px solid var(--hn-grey);
    position: relative;
    overflow: hidden;
  }

  .module-video-iframe{
    width: 100%;
    aspect-ratio: 16 / 9;
    border-radius: 0.5rem; /* rounded-lg */
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1),
                0 1px 2px rgba(0, 0, 0, 0.06); /* shadow */
    border: none;

  }

  .hero h1 {
    font-family: 'Montserrat';
    color: var(--hn-yellow);
    font-size: 2.6rem;
    margin-bottom: 0.2em;
    font-weight: 700;
    text-shadow: 0 0 8px var(--hn-yellow);
  }

  .terminal-bar {
    display: inline-block;
    font-family: 'Fira Mono', monospace;
    font-size: 1.4rem;
    background: var(--hn-grey);
    color: var(--hn-green);
    padding: 14px 32px 14px 28px;
    border-radius: 10px;
    margin-bottom: 42px;
    margin-top: 42px;
    box-shadow: 0 0 10px 1px rgba(0, 255, 0, 0.1);
    position: relative;
  }

  .blinking-cursor {
    display: inline-block;
    width: 10px;
    height: 1.3em;
    background: var(--hn-green);
    margin-left: 4px;
    animation: blink 1s steps(1) infinite;
    vertical-align: bottom;
  }

  @keyframes blink {

    0%,
    49% {
      opacity: 1;
    }

    50%,
    100% {
      opacity: 0;
    }
  }

  .hero p {
    color: var(--hn-white);
    font-size: 1.3rem;
    margin-top: 0.6em;
    max-width: 640px;
    margin-left: auto;
    margin-right: auto;
    opacity: 0.85;
  }

  .hero-stats {
    display: flex;
    justify-content: center;
    gap: 3rem;
    margin: 3rem 0;
    flex-wrap: wrap;
  }

  .stat {
    text-align: center;
  }

  .stat-number {
    font-size: 2.5rem;
    font-weight: 800;
    color: var(--hn-green);
    display: block;
  }

  .stat-label {
    color: var(--hn-green);
    font-size: 0.9rem;
  }

  .cta-primary {
    display: inline-block;
    margin-top: 28px;
    background: linear-gradient(90deg, var(--hn-green), var(--hn-yellow));
    color: var(--hn-black);
    font-weight: 700;
    padding: 16px 48px;
    font-size: 1.15rem;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
    font-family: 'Fira Mono', monospace;
  }

  .cta-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 0 12px 0 var(--hn-green);
  }

  .cta-secondary {
    background: transparent;
    color: var(--hn-white);
    padding: 1rem 2rem;
    border: 1px solid #333;
    border-radius: 12px;
    text-decoration: none;
    font-weight: 600;
    font-size: 1.1rem;
    display: inline-block;
    margin: 1rem 0.5rem;
    transition: all 0.3s ease;
    font-family: 'Fira Mono', monospace;
  }

  .cta-secondary:hover {
    border-color: var(--hn-yellow);
    color: var(--hn-yellow);
  }

  /* Side bar */
  .sidebar {
    position: fixed;
    left: -200px;
    top: 80px;
    width: 200px;
    background: #222;
    padding: 20px;
    border-right: 2px solid #00ff00;
    transition: left 0.3s ease;
    z-index: 1000;
    transform: translateX(-100%);
    transition: transform 0.3s ease-in-out;
  }

  .sidebar.open {
    left: 0;
    transform: translateX(0);

  }

  .sidebar-toggle {
    position: fixed;
    top: 80px;
    left: 10px;
    background: #00ff00;
    border: none;
    padding: 6px 10px;
    border-radius: 4px;
    cursor: pointer;
    z-index: 1100;
  }

  .module-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .module-item {
    padding: 8px;
    border-radius: 6px;
    margin-bottom: 6px;
  }

  .module-item.active {
    background: #00ff00;
    color: #000;
  }

  .module-item.locked {
    background: #333;
    color: #666;
  }



  /* Progress section */
  .progress-container {
    margin: 64px 64px 0 64px;
    max-width: 100%;
    background: var(--hn-black);
    border-radius: 12px;
    padding: 26px 36px;
    /* box-shadow: 0 0 8px 0 var(--hn-green); */
    display: flex;
    align-items: center;
    gap: 42px;
    flex-wrap: wrap;
    justify-content: center;
    border: 1px solid var(--hn-green);
  }

  .progress-left {
    flex: 2;
    min-width: 230px;
  }

  .progress-title {
    font-family: 'Fira Mono', monospace;
    font-size: 1.15rem;
    color: var(--hn-green);
    margin-bottom: 12px;
  }

  .progress-bar {
    width: 100%;
    height: 15px;
    background: var(--hn-black);
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 0 3px 1px var(--hn-green);
    margin-bottom: 8px;
  }

  .progress-fill {
    height: 100%;
    background: linear-gradient(90deg, var(--hn-green) 0%, var(--hn-yellow) 90%);
    border-radius: 6px 0 0 6px;
    transition: width 0.5s;
  }

  .progress-metrics {
    font-size: 1.01rem;
    color: var(--hn-yellow);
    font-family: 'Fira Mono', monospace;
    margin-top: 3px;
    opacity: 0.85;
  }

  .progress-right {
    flex: 1;
    min-width: 150px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media (max-width: 900px) {
    .progress-container {
      grid-template-columns: 1fr !important;
      gap: 36px !important;
      margin: 36px 16px 0 16px !important;
    }
  }

  .intro-section{
    width: 1000px;
    margin: 0px auto;
    .intro-learning{
      margin-bottom: 20px;
      padding-bottom: 20px;
    }
  }


  /* Step Progress Dots */
  .step-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: sticky;
    top: 0;
    background: var(--hn-black);
    z-index: 1;
    padding: 42px 16px;
  }

  .step-progress {
    display: flex;
    gap: 10px;
  }

  .step-desc {
    color: var(--hn-yellow);
    line-height: 1.6;
    font-weight: 500;
    font-family: 'Fira Mono';
    font-size: 1.1rem;
    text-align: center;
    margin: 0 24px;
  }

  .step-dot {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: var(--hn-light-grey);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    transition: all 0.3s ease;
    opacity: 0.6;
    font-family: 'Fira Mono';
  }

  .step-dot.active {
    background: var(--hn-yellow);
    opacity: 1;
    color: var(--hn-black);
  }

  .step-dot.completed {
    background: var(--hn-yellow);
    opacity: 0.5;
    color: var(--hn-black);
  }

  .step-buttons {
    display: flex;
    gap: 10px;
  }

  /* Step progress bar */
  .step-progress-bar-wrapper {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background: var(--hn-grey);
    border-radius: 1px;
    overflow: hidden;
  }

  .step-progress-bar {
    height: 100%;
    width: 0%;
    background: var(--hn-green);
    transition: width 0.3s ease;
  }

  /* Step message */
  .step-message {
    margin-top: 15px;
    font-style: italic;
    color: #00ff00;
    display: none;
  }


  .course-steps { 
    justify-self: center;
  }

  .course-steps .step.active {
    display: block;
    animation: fadeIn 0.4s ease;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Buttons */
  .next-btn,
  .prev-btn,
  .finish-btn {
    padding: 10px 18px;
    border: none;
    border-radius: 6px;
    font-family: 'Fira Mono', monospace;
    font-weight: 700;
    cursor: pointer;
    font-size: 1rem;
  }

  .next-btn {
    background: var(--hn-green);
    color: var(--hn-black);
    transition: all 0.3s ease;
  }

  .next-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 0 12px 0 var(--hn-green);
    color: var(--hn-black);
  }

  .prev-btn {
    background: var(--hn-grey);
    color: var(--hn-white);
    border: 1px solid var(--hn-light-grey);
  }

  .finish-btn {
    background: var(--hn-yellow);
    color: var(--hn-black);
  }

  #nextBtn:disabled, #finishBtn:disabled {
    background-color: #ccc;
    color: #666;
    cursor: not-allowed;
    opacity: 0.6;
    pointer-events: none;
    box-shadow: none;
    transform: none;
  }

  /* -------------------- */
  /* Mobile Friendly Step Navigation */
  @media (max-width: 600px) {
    .assignment-editor { width: auto !important; }
    .quiz-step{ margin: 5px !important; }
    .intro-section{ 
      width: 100%;
      .intro-learning{
        margin: 20px;
      }
    }
    .all-modules-card{
      margin: 15px;
    }
    .key-takeaway{
      margin: 20px !important;
    }
    .videos-section{
      width: 100%;
      .video-card{
        padding: 10px !important;
        margin: 20px !important;
        iframe{
          width: 100% !important;
          height: 270px !important;
        }
      }
    }
    .section-title{ margin: 20px; }
    .step-progress {
      justify-content: center;
      gap: 0;
    }

    .step-dot {
      display: none;
      margin-bottom: 12px;
    }

    .step-dot.active {
      display: flex;
    }

    /* hide the connecting progress bar on mobile */
    .step-progress-bar-wrapper {
      display: block;
    }

    .step-desc {
      font-size: 1rem;
      margin: 12px 24px;
    }

    .step-navigation {
      flex-direction: column;
      align-items: center;
      padding: 24px 12px;
    }

    .step-buttons {
      margin-top: 12px;
    }
  }




  /* NEW: simple participant circle */
  .pie-title {
    color: var(--hn-yellow);
    font-family: 'Fira Mono', monospace;
    font-size: 1.06rem;
    margin-bottom: 7px;
    text-align: center;
  }

  .participant-circle {
    width: 84px;
    height: 84px;
    border-radius: 50%;
    /* background: var(--hn-green); */
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    /* box-shadow: 0 2px 10px 0 rgba(209,255,3,0.16); */
  }

  .participant-circle span {
    color: var(--hn-yellow);
    font-size: 2.7rem;
    font-family: 'Montserrat', 'Fira Mono', monospace;
    font-weight: 900;
    letter-spacing: 1px;
  }

  /* Course Features */
  .section-title {
    color: var(--hn-yellow, #FECF38);
    font-size: 2.1rem;
    font-family: 'Fira Mono', monospace;
    margin-bottom: 64px;
    margin-top: 32px;
    text-align: center;
    font-weight: 700;
    margin-top: 64px;
    // padding-top: 50px;
    // margin: 0px;
  }

  .course-features {
    padding: 64px 64px;
    background: var(--hn-black);
  }

  .features-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    /* Default: 2 columns */
    gap: 2rem;
    margin-top: 3rem;
    padding: 64px 64px;
  }

  @media (min-width: 1000px) {
    .features-grid {
      grid-template-columns: repeat(4, 1fr);
      /* 4 columns on large screens */
    }
  }

  .feature-card {
    background: var(--hn-grey);
    padding: 2rem;
    border-radius: 16px;
    border: 1px solid var(--hn-light-grey);
    text-align: center;
    transition: all 0.3s ease;
  }

  .feature-card:hover {
    border-color: var(--hn-green);
    transform: translateY(-5px);
    box-shadow: var(--card-shadow-hover);
  }

  .feature-icon {
    font-size: 2.5rem;
    margin-bottom: 1rem;
  }

  .feature-card h3 {
    font-size: 1.3rem;
    font-weight: 700;
    margin-bottom: 1rem;
    color: var(--hn-green);
    font-family: 'Montserrat';
  }

  .feature-card p {
    color: var(--hn-white);
    line-height: 1.6;
    font-weight: 500;
    font-family: 'Montserrat';
    font-size: 1.1rem;
  }

  .certificate-card {
    margin-top: 3rem;
    background: linear-gradient(135deg, var(--hn-grey) 0%, rgba(0, 255, 0, 0.05) 100%);
    border: 1px solid var(--hn-green);
    border-radius: 16px;
    padding: 2.5rem;
    text-align: center;
    transition: all 0.3s ease;
  }

  .certificate-card:hover {
    border-color: var(--hn-yellow);
    transform: translateY(-5px);
    box-shadow: var(--card-shadow-hover);
  }

  .certificate-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2rem;
    flex-wrap: wrap;
  }

  .certificate-icon {
    font-size: 3rem;
    min-width: 60px;
  }

  .certificate-text {
    flex: 1;
    min-width: 300px;
    text-align: left;
  }

  .certificate-text h3 {
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--hn-green);
    margin-bottom: 1rem;
    font-family: 'Montserrat';
  }

  .certificate-text p {
    color: var(--hn-white);
    line-height: 1.6;
    font-size: 1.1rem;
    font-weight: 500;
  }

  @media (max-width: 768px) {
    .certificate-content {
      flex-direction: column;
      text-align: center;
    }

    .certificate-text {
      text-align: center;
      min-width: auto;
    }
  }




  /* All Modules Card */

  .all-modules-card {
    margin-top: 3rem;
    margin-bottom: 32px;
    background: linear-gradient(135deg, var(--hn-grey) 0%, rgba(255, 213, 0, 0.068) 100%);
    border: 1px solid var(--hn-green);
    border-radius: 16px;
    padding: 2.5rem;
    text-align: center;
    transition: all 0.3s ease;
  }

  .all-modules-card:hover {
    border-color: var(--hn-yellow);
    transform: translateY(-5px);
    box-shadow: var(--card-shadow-hover);
  }

  .all-modules-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2rem;
    flex-wrap: wrap;
  }


  .all-modules-text {
    flex: 1;
    min-width: 300px;
    text-align: left;
  }

  .all-modules-text h3 {
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--hn-green);
    margin-bottom: 1rem;
    font-family: 'Montserrat';
  }

  .all-modules-text p {
    color: var(--hn-white);
    line-height: 1.6;
    font-size: 1.1rem;
    font-weight: 500;
  }

  .all-modules-text strong {
    color: var(--hn-yellow);
  }

  @media (max-width: 768px) {
    .all-modules-content {
      flex-direction: column;
      text-align: center;
    }

    .all-modules-text {
      text-align: center;
      min-width: auto;
    }
  }

  /* Modules section */
  .modules-section {
    max-width: 100%;
    // padding: 64px 64px;
    background-color: var(--hn-black);
  }

  .modules-title {
    color: var(--hn-yellow, #FECF38);
    font-size: 2.1rem;
    font-family: 'Fira Mono', monospace;
    margin-bottom: 64px;
    margin-top: 32px;
    text-align: center;
    font-weight: 700;
  }

  .modules-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    /* Default: 2 columns */
    gap: 2rem;
    margin-top: 3rem;
    /* important */
  }

  @media (max-width: 1100px) {
    .modules-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (max-width: 700px) {
    .modules-grid {
      grid-template-columns: 1fr;
    }
  }



  .module-card {
    background: var(--hn-grey);
    padding: 2rem;
    border-radius: 16px;
    border: 1px solid var(--hn-light-grey);
    text-align: left;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    cursor: pointer;
    z-index: 1;
  }

  .module-card:hover {
    border-color: var(--hn-green);
    transform: translateY(-5px);
    box-shadow: var(--card-shadow-hover);
    z-index: 10;
  }

  .module-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    cursor: pointer;
    user-select: none;
    position: relative;
    padding-bottom: 0;
    gap: 8px;
  }

  .module-icon {
    margin-bottom: 12px;
    font-size: 2.5rem;
  }

  .module-title {
    font-size: 1.3rem;
    font-weight: 700;
    margin-bottom: 1rem;
    color: var(--hn-green);
    font-family: 'Montserrat';
    text-align: center;
  }

  .module-desc {
    color: var(--hn-yellow);
    line-height: 1.6;
    font-weight: 500;
    font-family: 'Montserrat';
    font-size: 1.1rem;
  }

  .module-body {
    max-height: 0;
    overflow: hidden;
    /* background: #222318; */
    transition: max-height 0.36s cubic-bezier(.29, 1.39, .48, .91), padding 0.26s;
    font-size: 1.2rem;
    color: var(--hn-white);
    padding: 0;
    width: 100%;
    margin: 0 auto;
  }

  .module-card.expanded .module-body {
    max-height: 600px;
    padding: 8px 0;
  }

  .module-btn,
  .module-body a {
    cursor: pointer !important;
    display: block;
    width: 100%;
    margin-top: 32px;
    background: linear-gradient(90deg, var(--hn-green), var(--hn-yellow));
    color: var(--hn-black);
    font-weight: 800;
    padding: 14px 0;
    font-size: 1.1rem;
    border: none;
    border-radius: 8px;
    box-shadow: 0 0 7px 0 var(--hn-green);
    transition: all 0.3s ease;
    text-decoration: none;
    text-align: center;
    font-family: 'Fira Mono', monospace;
  }

  .module-btn:hover {
    transform: translateY(-5px);
  }

  @media (max-width: 600px) {
    .modules-section {
      padding: 14px 2vw;
    }

    .modules-title {
      font-size: 1.25rem;
    }
  }

  /*  Video */

  .video-card {
    background: var(--hn-grey);
    padding: 32px;
    border-radius: 18px;
    border: 1.5px solid var(--hn-light-grey);
    text-align: center;
    transition: all 0.3s;
    max-width: 100%;
    // min-width: 1000px;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 32px 64px;
  }

  .video-card:hover {
    border-color: var(--hn-green);
    transform: translateY(-5px);
    box-shadow: var(--card-shadow-hover);
  }

  .video-card h3 {
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--hn-green);
    margin-bottom: 1rem;
    font-family: 'Montserrat';
  }

  .video-card p {
    color: var(--hn-white);
    opacity: 0.87;
    font-size: 1.1rem;
    margin-bottom: 32px;
    text-align: center;
    font-family: "Montserrat";
  }

  
  .video-card video {
    border-radius: 12px;
    background: #111;
    margin: 0 auto;
    display: block;
    height: 350px;
    /* Set your preferred fixed height */
    object-fit: cover;
    width: 100%;
  }

  .video-card.watched {
    border: 1px solid var(--hn-green);
    position: relative;
  }

  .watched-badge {
    position: absolute;
    top: 18px;
    left: 50%;
    transform: translateX(-50%);
    background: var(--hn-green);
    color: var(--hn-black);
    font-weight: 900;
    font-size: 1.07rem;
    font-family: 'Fira Mono', monospace;
    border-radius: 14px;
    padding: 0.35rem 1.4rem;
    box-shadow: 0 2px 6px 0 rgba(0, 255, 0, 0.07);
    letter-spacing: 1px;
    z-index: 2;
    opacity: 0.98;
    animation: pop-in-badge 0.35s cubic-bezier(.54, 1.7, .47, .99);
  }

  @keyframes pop-in-badge {
    0% {
      transform: translateX(-50%) scale(0.6);
      opacity: 0;
    }

    80% {
      transform: translateX(-50%) scale(1.12);
    }

    100% {
      transform: translateX(-50%) scale(1);
      opacity: 0.98;
    }
  }

  .key-takeaway {
    margin: 64px 64px;
    background: linear-gradient(135deg, var(--hn-grey) 0%, rgba(255, 213, 0, 0.068) 100%);
    border: 1px solid var(--hn-green);
    border-radius: 16px;
    padding: 2.5rem;
    text-align: center;
    transition: all 0.3s ease;
  }

  .key-takeaway:hover {
    border-color: var(--hn-yellow);
    transform: translateY(-5px);
    box-shadow: var(--card-shadow-hover);
  }


  .video-nav {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    margin-top: 16px;
  }


  .prev-video-btn,
  .next-video-btn,
  .finish-video-btn {
    margin-top: 16px;
    padding: 12px 24px;
    border: none;
    border-radius: 8px;
    font-family: 'Fira Mono', monospace;
    font-weight: 700;
    cursor: pointer;
    background: linear-gradient(90deg, var(--hn-green), var(--hn-yellow));
    color: var(--hn-black);
    transition: all 0.3s ease;
  }


  .prev-video-btn:hover,
  .next-video-btn:hover,
  .finish-video-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 0 12px 0 var(--hn-green);
  }

  /* Greyed out disabled */
  .prev-video-btn:disabled,
  .next-video-btn:disabled,
  .finish-video-btn:disabled {
    background: #ccc;
    /* grey background */
    color: #666;
    /* lighter text */
    cursor: not-allowed;
    /* forbidden cursor */
    box-shadow: none;
    /* remove glow */
    transform: none;
    /* prevent hover shift */
    opacity: 0.6;
    /* slightly faded look */
  }

  /* Download materials */

  .downloads-section {
    // padding: 64px 64px 40px 64px;
    // background: var(--hn-black);
  }

  .downloads {
    display: flex;
    gap: 2.2rem;
    max-width: 900px;
    flex-wrap: wrap;
    margin: 0 auto;
    margin-top: 2rem;
    justify-content: center;
    margin-bottom: 64px;
  }

  .download-card {
    background: var(--hn-grey);
    width: 300px;
    border: 1.5px solid var(--hn-light-grey);
    border-radius: 15px;
    padding: 32px 32px;
    text-align: center;
    transition: border-color 0.28s, box-shadow 0.28s;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    min-height: 250px;
    position: relative;
  }

  .download-card:hover {
    border-color: var(--hn-green);
    box-shadow: 0 6px 24px 0 rgba(209, 255, 3, 0.13);
  }

  .download-icon {
    font-size: 2.5rem;
    margin-bottom: 1.1rem;
    color: var(--hn-green);
  }

  .download-title {
    font-size: 1.2rem;
    font-weight: 700;
    color: var(--hn-green);
    margin-bottom: 0.7rem;
    font-family: 'Montserrat';
  }

  .download-desc {
    color: var(--hn-white);
    opacity: 0.88;
    font-size: 1.1rem;
    margin-bottom: 2.1rem;
    font-family: 'Montserrat';
    min-height: 48px;
  }

  .download-btn {
    background: linear-gradient(90deg, var(--hn-green), var(--hn-yellow));
    color: var(--hn-black);
    font-weight: 800;
    padding: 13px 0;
    width: 100%;
    font-size: 1.07rem;
    border: none;
    border-radius: 8px;
    box-shadow: 0 0 7px 0 var(--hn-green);
    transition: all 0.22s;
    text-decoration: none;
    font-family: 'Fira Mono', monospace;
    display: inline-block;
    cursor: pointer;
  }

  .download-btn:hover {
    transform: translateY(-2px) scale(1.035);
    background: linear-gradient(90deg, var(--hn-yellow), var(--hn-green));
    color: var(--hn-black);
  }

  /* Assignments */

  .assignment-section {
    padding: 0px 64px;
    background: var(--hn-grey);
    max-width: 100%;
    margin: 0 auto 60px auto;

    @media (max-width: 768px) {
      padding: 0px 10px;
      .url-input { width: 93% !important; }
    }
  }

  .assignment-guidelines {
    background: var(--hn-grey);
    border: 1.5px solid var(--hn-green);
    border-radius: 14px;
    padding: 2rem 2rem 1.7rem 2rem;
    margin-bottom: 2rem;
    color: var(--hn-white);
  }

  .assignment-guidelines h3 {
    color: var(--hn-green);
    margin-bottom: 1.2rem;
    font-family: 'Montserrat', sans-serif;
    font-size: 1.2rem;
  }

  .assignment-guidelines ol {
    font-size: 1.09rem;
    margin: 0 0 0 1rem;
    padding-left: 1rem;
    line-height: 1.8;
  }

  .assignment-guidelines a {
    color: var(--hn-yellow);
    text-decoration: underline;
  }

  .assignment-upload-form {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
  }

  .upload-label {
    display: flex;
    align-items: center;
    justify-content: center;
    /* center icon + text inside */
    margin: 0 auto;
    /* center the whole button in its container */
    gap: 12px;
    background: var(--hn-green);
    color: var(--hn-black);
    font-weight: 700;
    border-radius: 8px;
    padding: 1.2rem 2.2rem;
    cursor: pointer;
    font-size: 1.09rem;
    box-shadow: 0 2px 12px 0 rgba(209, 255, 3, 0.11);
    transition: all 0.3s ease;
    font-family: 'Fira Mono', monospace;
  }

  .upload-label:hover {
    background: var(--hn-yellow);
    color: var(--hn-black);
    box-shadow: 0 4px 18px 0 rgba(254, 207, 56, 0.13);
    transform: translateY(-5px);
  }

  .upload-icon {
    font-size: 1.6rem;
  }

  .upload-input {
    display: none;
  }

  .assignment-check {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .assignment-check input[type="checkbox"] {
    width: 22px;
    height: 22px;
    accent-color: var(--hn-green);
    cursor: pointer;
  }

  #checkbox-label {
    color: var(--hn-green);
    font-family: 'Fira Mono', monospace;
    font-size: 1.07rem;
    opacity: 0.82;
    user-select: none;
  }

  .assignment-editor {
    margin: 32px 0;
    padding: 32px;
    background: var(--hn-grey);
    /* match dark page */
    border: 1px solid var(--hn-yellow);
    border-radius: 12px;
    width: 1100px;
    .url-input{
      padding: 10px;
      width: 50%;
      font-size: 16px;
      background: #000000;
      border: 1px solid var(--hn-yellow);
      border-radius: 5px;
      color: #ffffff;
    }
  }

  .assignment-editor label {
    display: block;
    font-weight: 400;
    color: var(--hn-yellow);
    /* make it pop */
    margin-bottom: 1.2rem;
    font-family: 'Montserrat', sans-serif;
    font-size: 1.2rem;
  }

  /* Toolbar buttons */
  #editor-toolbar button {
    color: var(--hn-yellow);
    border: none;
    width: 32px;
    height: 32px;
    margin-right: 12px;
  }

  #editor-toolbar button:hover {
    background: var(--hn-green);
    /* pop of green */
    color: var(--hn-black);
    border-radius: 4px;
    transition: background 0.2s ease;
  }

  /* Toolbar wrapper */
  #editor-toolbar {
    background: var(--hn-grey);
    border: 1px solid var(--hn-light-grey);
    border-radius: 8px 8px 0 0;
    /* curved top corners */
    padding: 6px 8px;
    margin-bottom: 0;
    display: flex;
    align-items: center;
  }

  /* Editor container */
  #editor-container {
    min-height: 220px;
    background: #111;
    color: #eee;
    border: 1px solid var(--hn-light-grey);
    border-top: none;
    border-radius: 0 0 8px 8px;
    font-size: 1rem;
    line-height: 1.6;
    padding: 14px 16px;
  }

  /* Quill editor text styles */
  .ql-editor {
    font-family: 'Fira Mono', monospace;
    font-size: 1rem;
    color: var(--hn-white);
    padding: 0px;
  }

  .ql-editor.ql-blank::before {
    color: var(--hn-light-grey);
    font-style: italic;
  }

  /* Default toolbar icons → Yellow */
  #editor-toolbar .ql-stroke,
  #editor-toolbar .ql-fill {
    stroke: var(--hn-yellow) !important;
    fill: var(--hn-yellow) !important;
  }

  /* Dropdowns (fonts, headers, etc.) also yellow */
  #editor-toolbar .ql-picker-label,
  #editor-toolbar .ql-picker-item {
    color: var(--hn-yellow) !important;
  }

  /* Active button state → Green */
  #editor-toolbar button.ql-active .ql-stroke,
  #editor-toolbar button.ql-active .ql-fill {
    stroke: var(--hn-green) !important;
    fill: var(--hn-green) !important;
  }

  /* Hover → keep your green background effect */
  #editor-toolbar button:hover {
    background: var(--hn-light-grey);
    color: var(--hn-black);
    border-radius: 4px;
    transition: background 0.2s ease;
  }

  .value-container {
    padding: 32px 64px 64px 64px;
    background: var(--hn-black);
    border-radius: 16px;
  }

  .value-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    /* Default: 2 columns */
    gap: 32px;
  }

  @media (max-width: 900px) {
    .value-grid {
      grid-template-columns: 1fr;
      /* 1 column on small screens */
    }
  }

  .value-card {
    background: var(--hn-grey);
    padding: 2rem;
    border-radius: 16px;
    border: 1px solid var(--hn-light-grey);
    text-align: center;
    transition: all 0.3s ease;
  }

  .value-card:hover {
    border-color: var(--hn-green);
    transform: translateY(-5px);
    box-shadow: var(--card-shadow-hover);
  }

  .value-icon {
    font-size: 2.5rem;
    margin-bottom: 1rem;
  }

  .value-card h3 {
    font-size: 1.3rem;
    font-weight: 700;
    margin-bottom: 1rem;
    color: var(--hn-green);
    font-family: 'Montserrat';
  }

  .value-card p {
    color: var(--hn-white);
    line-height: 1.6;
    font-weight: 500;
    font-family: 'Montserrat';
    font-size: 1.1rem;
  }



  /* Testimonials */

  .testimonial-section {
    background: var(--hn-grey);
    padding: 64px 0 64px 0;
    text-align: center;
  }

  .testimonial-title {
    color: var(--hn-yellow, #FECF38);
    font-size: 2.1rem;
    font-family: 'Fira Mono', monospace;
    margin-bottom: 32px;
    text-align: center;
    font-weight: 700;
  }

  .testimonial-grid {
    display: flex;
    gap: 32px;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    scroll-padding: 32px;
    padding: 32px 64px;
    scroll-behavior: smooth;
    scrollbar-width: none;
    /* Firefox */
  }

  .testimonial-card {
    background: var(--hn-grey);
    border: 1px solid var(--hn-green, #D1FF03);
    border-radius: 18px;
    box-shadow: 0 5px 30px 0 rgba(0, 255, 0, 0.08);
    padding: 32px 28px 24px 28px;
    max-width: 350px;
    text-align: left;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    transition: box-shadow 0.18s, border 0.18s, transform 0.16s;
    justify-content: space-between;
    max-width: 600px;
    min-width: 380px;

    /* ensures spacing between quote and person */
  }

  .testimonial-card:hover {
    box-shadow: 0 8px 32px 0 rgba(254, 207, 56, 0.17);
    border-color: var(--hn-yellow, #FECF38);
    transform: translateY(-5px);
  }

  .testimonial-quote {
    color: var(--hn-white);
    line-height: 1.6;
    font-weight: 500;
    font-family: 'Montserrat';
    font-size: 1rem;
    margin-bottom: 32px;
  }

  .testimonial-person {
    display: flex;
    align-items: top;
    gap: 14px;
  }

  .testimonial-avatar {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    border: 1px solid var(--hn-yellow, #FECF38);
    background: #fff;
    object-fit: cover;
  }

  .testimonial-name {
    font-size: 1.1rem;
    font-weight: 700;
    margin-bottom: 6px;
    color: var(--hn-green);
    font-family: 'Montserrat';
  }

  .testimonial-role {
    color: var(--hn-white);
    line-height: 1.6;
    font-weight: 500;
    font-family: 'Montserrat';
    font-size: 1rem;
  }

  /* Content Ownership */
  .content-ownership {
    padding: 64px 64px;
    background: var(--hn-black);
  }

  .ownership-content {
    display: grid;
    grid-template-columns: 1fr;
    gap: 3rem;
    align-items: center;
  }

  @media (min-width: 768px) {
    .ownership-content {
      grid-template-columns: 2fr 1fr;
      gap: 4rem;
    }
  }

  .ownership-text p {
    font-size: 1.1rem;
    margin-bottom: 1.5rem;
    color: var(--hn-white);
    line-height: 1.7;
    font-weight: 500;
  }

  .ownership-text strong {
    color: var(--hn-green);
  }

  .ownership-image {
    display: flex;
    justify-content: center;
  }

  .ownership-icon {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .document-stack {
    position: relative;
    width: 240px;
    height: 300px;
  }

  .document {
    position: absolute;
    width: 160px;
    height: 200px;
    background: var(--hn-green);
    border-radius: 8px;
    border: 4px solid var(--hn-black);
  }

  .document::before {
    content: '';
    position: absolute;
    top: 20px;
    left: 20px;
    right: 20px;
    height: 6px;
    background: var(--hn-black);
    border-radius: 2px;
  }

  .document::after {
    content: '';
    position: absolute;
    top: 40px;
    left: 20px;
    right: 40px;
    height: 4px;
    background: var(--hn-black);
    border-radius: 1px;
  }

  .doc-1 {
    transform: rotate(-5deg);
    z-index: 1;
  }

  .doc-2 {
    transform: rotate(0deg);
    z-index: 2;
    left: 40px;
  }

  .doc-3 {
    transform: rotate(5deg);
    z-index: 3;
    left: 80px;
  }

  .ownership-badge {
    margin-top: 2rem;
    background: var(--hn-green);
    color: var(--hn-black);
    padding: 0.75rem 2rem;
    border-radius: 25px;
    font-weight: 700;
    font-size: 1.1rem;
    letter-spacing: 1px;
  }


  /* Pricing */
  .pricing {
    padding: 64px 64px 32px 64px;
    text-align: center;
  }

  .pricing-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 2rem;
    margin-top: 3rem;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
  }

  .pricing-card {
    background: var(--hn-grey);
    padding: 2.5rem 2rem;
    border-radius: 16px;
    border: 1px solid var(--hn-light-grey);
    position: relative;
    transition: all 0.3s ease;
    font-weight: 500;
  }

  .pricing-card:hover {
    border: 1px solid var(--hn-yellow);
  }

  .pricing-card.featured:hover {
    border: 1px solid var(--hn-yellow);
  }

  .pricing-card.featured {
    border-color: var(--hn-green);
  }

  .popular-badge {
    position: absolute;
    top: -15px;
    left: 50%;
    transform: translateX(-50%);
    background: var(--hn-green);
    color: var(--hn-black);
    padding: 0.5rem 1.5rem;
    border-radius: 20px;
    font-size: 0.8rem;
    font-weight: 700;
    font-family: 'Montserrat';
  }

  .price {
    font-size: 3rem;
    font-weight: 800;
    color: var(--hn-green);
    margin: 1rem 0;
    font-family: 'Montserrat';
  }

  .price-period {
    color: var(--hn-yellow);
    font-size: 1rem;
  }

  .features {
    list-style: none;
    margin: 2rem 0;
    text-align: left;
  }

  .features li {
    padding: 0.5rem 0;
    position: relative;
    padding-left: 2rem;
  }

  .features li::before {
    content: '✓';
    color: var(--hn-green);
    font-weight: 700;
    position: absolute;
    left: 0;
  }

  /* FAQ */

  .faq {
    padding: 64px 64px;
    background: var(--hn-grey);
  }

  .faq-item {
    background: var(--dark-bg);
    margin-bottom: 1rem;
    border-radius: 12px;
    border: 1px solid var(--hn-light-grey);
    overflow: hidden;
    transition: all 0.3s ease;
  }

  .faq-item:hover {
    border: 1px solid var(--hn-green);
  }

  .faq-question {
    padding: 1.5rem 2rem;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 600;
    font-family: 'Montserrat';
    font-weight: 700;
  }

  .faq-answer {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
    font-family: 'Montserrat';
    font-weight: 500;
  }

  .faq-answer.active {
    max-height: 200px;
  }

  .faq-answer-content {
    padding: 0 2rem 1.5rem;
    color: var(--text-secondary);
  }

  .faq-toggle {
    font-size: 1.5rem;
    transition: transform 0.3s ease;
  }

  .faq-toggle.active {
    transform: rotate(45deg);
  }

  /* Footer CTA */
  .footer-cta {
    padding: 64px 64px;
    text-align: center;
    background: var(--hn-black);
    font-size: 1.2rem;
  }

  /* Default: 5 columns */
  .footer {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 32px;
    padding: 64px 5vw;
    background: var(--hn-black);
    border-top: 1px solid var(--hn-yellow);
  }

  /* Footer links styling */
  .footer-links-title {
    font-weight: bold;
    color: var(--hn-green);
    margin-bottom: 12px;
    font-size: 1.2rem;
    letter-spacing: 0.1px;
    font-family: 'Fira Mono', monospace;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .footer-links-title::after {
    content: "+";
    font-size: 1.2rem;
    transition: transform 0.3s ease;
  }

  .footer-links.open .footer-links-title::after {
    content: "−";
  }

  .footer-links-list {
    display: flex;
    flex-direction: column;
    gap: 7px;
  }

  .footer-link {
    color: #f8fae8;
    text-decoration: none;
    opacity: 0.88;
    font-size: 0.9rem;
    font-family: 'Montserrat';
    font-weight: 500;
    line-height: 1.6;
    transition: color 0.14s, opacity 0.14s;
  }

  .footer-link:hover {
    color: var(--hn-yellow);
    opacity: 1;
  }

  /* Social section */
  .footer-social-title {
    color: var(--hn-yellow);
    font-size: 1.2rem;
    margin-bottom: 24px;
    font-weight: bold;
    font-family: 'Fira Mono', monospace;
  }

  .footer-social-icons {
    display: flex;
    gap: 18px;
    flex-wrap: wrap;
    align-items: center;
  }

  .footer-social-icon {
    width: 32px;
    height: 32px;
    opacity: 0.83;
    fill: var(--hn-yellow);
    cursor: pointer;
    transition: opacity 0.16s, transform 0.14s;
  }

  .footer-social-icon:hover {
    opacity: 1;
    transform: scale(1.12);
    fill: var(--hn-green);
  }

  /* Hide +/− on desktop screens */
  @media (min-width: 1101px) {
    .footer-links-title::after {
      content: none;
    }
  }

  /* Responsive Accordion */
  @media (max-width: 1100px) {
    .footer {
      grid-template-columns: 1fr;
      gap: 20px;
      padding: 32px 5vw;
    }

    /* Hide links by default */
    .footer-links-list {
      display: none;
    }

    /* Show links when open */
    .footer-links.open .footer-links-list {
      display: flex;
    }

    /* Social always visible */
    .footer-social {
      order: 5;
    }

    .footer-copyright {
      order: 6
    }
  }

  .footer-copyright {
    grid-column: 1 / -1;
    text-align: center;
    color: var(--hn-light-grey);
    font-size: 0.95rem;
    padding-top: 16px;
    border-top: 1px solid var(--hn-light-grey);
    margin-top: 32px;
  }


  /* Scroll animation */

  .scroll-animate {
    opacity: 0;
    transform: translateY(40px) scale(0.97);
    transition: opacity 0.8s cubic-bezier(.21, .97, .59, 1), transform 0.9s cubic-bezier(.21, .97, .59, 1);
    will-change: opacity, transform;
  }

  .scroll-animate.visible {
    opacity: 1;
    transform: translateY(0) scale(1);
  }


  /* Quiz */

  .quiz-feedback {
    margin-top: 10px;
    font-weight: bold;
  }

  .quiz-feedback.correct {
    color: #00ff00;
  }

  .quiz-feedback.incorrect {
    color: #ff5555;
  }

  .quiz-form label.correct {
    color: green;
    font-weight: bold;
  }

  .quiz-form label.incorrect {
    color: red;
    font-weight: bold;
  }

  .quiz-step h3 {
    color: var(--hn-yellow);
    line-height: 1.6;
    font-weight: 700;
    font-family: 'Montserrat';
    font-size: 1.3rem;
    text-align: center;
    margin-bottom: 32px;
    /* some spacing under the heading */
  }

  .quiz-form {
    color: var(--hn-yellow);
    line-height: 1.6;
    font-weight: 500;
    font-family: 'Montserrat';
    font-size: 1.1rem;

    /* NEW: grid layout for answers */
    display: grid;
    gap: 1rem;
    grid-template-columns: repeat(2, 1fr);
  }

  .quiz-step {
    display: inline-block;
    /* shrink to fit content */
    max-width: 100%;
    /* optional: keep it from being too wide */
    width: auto;
    /* don’t force 100% */
    margin: 64px 64px;
    /* center in container */
    background: var(--hn-dark);
    border: 1px solid var(--hn-green);
    border-radius: 12px;
    padding: 32px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }

  .quiz-step:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.3);
  }

  .quiz-option {
    display: block;
    border: 1px solid var(--hn-light-grey);
    border-radius: 12px;
    padding: 16px 24px;
    cursor: pointer;
    transition: all 0.2s ease;
    background: var(--hn-grey);
    color: var(--hn-white);
    text-align: left;
    /* left text inside cards */
  }

  .quiz-option:hover {
    border-color: var(--hn-green);
    background: var(--hn-grey);
  }

  .quiz-option input {
    display: none;
  }

  /* Answer highlight states */
  .quiz-option.correct {
    border-color: var(--hn-green);
    background: var(--hn-grey);
    color: var(--hn-green);
    font-weight: 600;
  }

  .quiz-option.incorrect {
    border-color: var(--hn-incorrect);
    background: var(--hn-grey);
    color: var(--hn-incorrect);
    font-weight: 600;
  }

  .quiz-option.correct,
  .quiz-option.correct * {
    color: var(--hn-green) !important;
  }

  /* NEW: responsive layout for mobile */
  @media (max-width: 768px) {
    .quiz-form {
      grid-template-columns: 1fr;
    }
  }

`

export {ModulePageLayout}